import { gql } from '$lib/apollo';

export const PURCHASED_PRODUCT_FIELDS = gql`
  fragment PurchasedProduct on API_PurchasedProductSubscription {
    id
    state
    product {
      id
      name
    }
    currentPeriodEndsAt
    currentPeriodStartedAt
    currentTermEndsAt
    currentTermStartedAt
    expiresAt
    trialEndsAt
    trialStartedAt
    updatedAt
    account {
      id
    }
  }
`;

export const PREVIEW_SUBSCRIPTION_PURCHASE = gql`
  mutation PurchasePreview($input: PurchasePreviewInput!) {
    purchasePreview(input: $input) {
      result {
        order {
          id
          fees
          total
          totalDue
          taxes
          subTotal
          items {
            id
            addonsTotal
            total
            subTotal
            product {
              id
              name
              sku
              productType
              seller {
                id
                slug
              }
            }
          }
        }
      }

      errors {
        ... on ValidationError {
          code
          message
        }
      }
    }
  }
`;

export const PURCHASE_SUBSCRIPTION = gql`
  mutation PurchaseCreate($input: PurchaseCreateInput!) {
    purchaseCreate(input: $input) {
      result {
        paymentGatewayResponse {
          id
          code
          secureToken
          customerMessage
        }
        order {
          id
          state
          createdAt
          updatedAt
          subTotal
          fees
          taxes
          total
          totalDue
          items {
            id
            addonsTotal
            product {
              id
              name
              sku
              productType
              seller {
                id
                slug
              }
            }
          }
          payments {
            createdAt
            fees
            id
            order {
              id
              state
            }
            paymentType
            state
            subTotal
            tax
            total
            updatedAt
          }
        }
      }

      errors {
        ... on NotAuthenticatedError {
          code
          message
        }
        ... on NotAuthorizedError {
          code
          message
        }
        ... on ValidationError {
          code
          message
        }
      }
    }
  }
`;

export const SUBSCRIPTION_CANCEL = gql`
  mutation SubscriptionCancel($input: SubscriptionCancelInput!) {
    subscriptionCancel(input: $input) {
      result {
        ...PurchasedProduct
      }

      errors {
        ... on Error {
          code
          message
        }
      }
    }
  }
  ${PURCHASED_PRODUCT_FIELDS}
`;

export const SUBSCRIPTION_CANCEL_FEEDBACK = gql`
  mutation subscriptionCancelationFeedback($input: SubscriptionCancelationFeedbackInput!) {
    subscriptionCancelationFeedback(input: $input) {
      result {
        ...PurchasedProduct
      }

      errors {
        ... on Error {
          code
          message
        }
      }
    }
  }
  ${PURCHASED_PRODUCT_FIELDS}
`;

export const SUBSCRIPTION_REACTIVATE = gql`
  mutation SubscriptionReactivate($input: SubscriptionReactivateInput!) {
    subscriptionReactivate(input: $input) {
      result {
        ...PurchasedProduct
      }

      errors {
        ... on Error {
          code
          message
        }
      }
    }
  }
  ${PURCHASED_PRODUCT_FIELDS}
`;

export const SUBSCRIPTION_DOWNGRADE_TIER = gql`
  mutation SubscriptionDowngradeTier($input: SubscriptionDowngradeTierInput!) {
    subscriptionDowngradeTier(input: $input) {
      result {
        ...PurchasedProduct
      }

      errors {
        ... on Error {
          code
          message
        }
      }
    }
  }
  ${PURCHASED_PRODUCT_FIELDS}
`;

export const SUBSCRIPTION_DOWNGRADE_CANCEL = gql`
  mutation SubscriptionDowngradeCancel($input: SubscriptionDowngradeCancelInput!) {
    subscriptionDowngradeCancel(input: $input) {
      result {
        ...PurchasedProduct
      }

      errors {
        ... on Error {
          code
          message
        }
      }
    }
  }
  ${PURCHASED_PRODUCT_FIELDS}
`;
